import { createFileRoute } from '@tanstack/react-router'
import { PopularDomains, ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DomainTool } from '@/components/tool-page/domain-tool'
import { POPULAR_APEX_SITES } from '@/lib/popular-sites'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['domain-expiry-checker']

export const Route = createFileRoute('/_site/tools/domain-expiry-checker')({
  component: DomainExpiryCheckerPage,
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
  head: () => toolHead(content),
})

function DomainExpiryCheckerPage() {
  const { q } = Route.useSearch()
  return (
    <ToolPage content={content} extra={<PopularDomains toolPath="/tools/domain-expiry-checker" heading="Check the expiry date of a popular domain" sites={POPULAR_APEX_SITES} />}>
      <DomainTool content={content} variant="expiry" initialDomain={q ?? ''} autoRun={!!q} />
    </ToolPage>
  )
}
